export const title = '豆币用户协议';

export const content = `
<h1>豆币用户协议</h1>
<h3>特别提示</h3>
《豆币用户协议》（以下简称“本协议”）适用于所有使用豆币的用户（以下或称“您”）。本协议一经同意并接受，即形成您与PaperWonder间具有法律约束力之文件。您确认，您已详细阅读了本协议所有内容，您充分理解并同意接受本协议的全部内容。PaperWonder还需要提醒您的是，如本协议内容发生修改或更新，PaperWonder将会在豆币充值面板提示修改内容并公布。您在使用PaperWonder提供的各项服务之前，应仔细阅读本协议，如您不同意变更后的协议内容，应立即停用豆币服务。

您的使用行为（包括但不限于点击充值、支付行为等）将视为您同意接受本协议及相关协议规范。您充值和/或使用豆币时，可能会因为您使用的软件版本、设备、操作系统等不同以及第三方原因造成差别，由此可能给您带来的不便，您表示理解，并不会因此向PaperWonder提出任何主张或追究PaperWonder任何责任。

如果您为未成年人，请在法定监护人的陪同下阅读和判断是否同意本协议。

<h3>豆币使用规则</h3>
1.豆币是PaperWonder为您提供的用于在PaperWonder平台上进行消费的虚拟币，只可用于购买PaperWonder平台上的各种虚拟产品和增值服务。 豆币和人民币的兑换比例是 1:1。 豆币在任何情况下都不能兑换成法定货币，请您根据自己的实际需求购买相应数量的豆币。

2.豆币充值就是用人民币购买豆币。您仅可为自己充值，充值成功后可用豆币在PaperWonder平台消费。您必须采用PaperWonder指定的充值方式进行充值，以增加您账户所拥有的豆币数量，可供充值方式包括但不限于：支付宝、微信、苹果内购、等（具体充值方式仍以PaperWonder实际展示为准）。您知晓并确认，若使用非PaperWonder所指定的方式或渠道进行 豆币充值，或以非法的方式进行 豆币充值而造成用户权益受损时，不得因此要求PaperWonder作任何补偿或赔偿。

3.用户必须为绑定的支付渠道账户开户人/持有人，可合法、有效使用该账户且未侵犯任何第三方权益，否则因此造成支付账户实际所有人损失的，应由用户单独负责解决由此产生的纠纷并承担全部法律责任。

4.您知晓并承诺，在使用豆币时不进行如下行为：
（1）以营利、经营等非个人使用目的充值豆币；
（2）以非PaperWonder指定的方式或渠道充值豆币；
（3）通过任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件等任何程序、软件方式充值豆币；
（4）通过侵犯PaperWonder或他人合法权益的方式充值豆币；
（5）利用PaperWonder现有或潜在的软件或规则漏洞或与PaperWonder合作的或关联的第三方产品（如支付渠道等）漏洞充值豆币；
（6）通过任何不正当手段或以违反诚实信用原则的方式充值豆币；
（7）通过任何其他违反相关法律、行政法规、国家政策的方式充值豆币；

5.您知晓并确认，用户一旦充值成功，豆币充值即确定完成。PaperWonder不提供退还或逆向兑换服务。

6.您知晓并确认，iOS平台仅支持iOS内购充值，且iOS充值的豆币仅可在iOS平台使用。

7.您知晓并确认，未使用的 豆币会进入您的豆币账户，PaperWonder终止运营或者运营权发生转移的，应提前 60日予以公告。用户尚未使用的 豆币及尚未失效的服务，应当按用户购买时的比例，以法定货币退还用户或者以用户接受的其他方式进行退还。

8.您知晓并确认，在使用 豆币充值系统时，您必须仔细确认充值账号，若因为您自身未登录账号、输入账号错误、操作不当或不了解充值计费方式等个人因素造成当前游客账号登出、充错账号、错选充值金额等情形而损害自身权益，由此带来的损失由用户自行承担。若因充值系统原因造成您充值失实，在您提供合法有效凭证的情况下，造成 豆币充值额小于您实际充值额的，PaperWonder予以补其差额，若大于您实际充值额的，PaperWonder有权追回差额。

9.您可随时在网页端或手机APP上查看您的账户豆币余额。如您对该记录有异议，应立即向PaperWonder提出，PaperWonder核对后确有错误的，将予以改正；否则您同意PaperWonder平台上的交易记录作为豆币充值和消费的唯一有效依据。

10.您知晓并确认，如您违反本协议任何条款，PaperWonder均有权不经您事先同意而对您或您的账号进行如下处理：
（1）对您账号的豆币充值和消费功能进行临时冻结，冻结期限由PaperWonder视情况决定；
（2）对您的账号进行永久封禁；
（3）对您账号（或有证据证明与您关联或由您控制的其他账号）中的豆币余额或其他虚拟产品进行全部或部分扣除；
（4）中止或终止向您的账号（或有证据证明与您关联或由您控制的其他账号）提供增值服务；
（5）要求您以法定货币等价返还已经消费的、以非正常方式充值的豆币（包括以打赏、赠予等方式已经消费掉的豆币）；
（6）要求您进一步赔偿给PaperWonder造成的损失；
（7）若您的行为已涉及违法犯罪，则PaperWonder有权移交司法机关处理。

PaperWonder有权依据您行为的性质和严重程度决定对您或您的账号采取上述一种或多种处理方式。在您的行为给PaperWonder造成的影响或损失未消除或未得到弥补前，PaperWonder有权决定对您或您的账号持续采取上述处理方式。如您对上述处理方式不服或有疑问，您可以联系客服进行申诉，但您需要提供客观、真实、有效的证据，包括但不限于充值记录、消费记录等。

11.您知晓并确认， 豆币支付使用PaperWonder平台的统一密码，请妥善保管好您的密码。当您的账户遇到争议时（例如挂失或重置密码），我们有权根据您的注册和绑定信息对您的身份进行识别。但在目前的技术水平下，我们所能采取的方法有限，且在网络上进行用户身份识别存在一定的困难，因此，我们对鉴定用户身份的准确性和绝对真实性不做任何保证。

12.您可以凭注册信息及注册联系方式联系客服挂失冻结账户，但如因您本人的挂失时间延迟，而导致此期间内发生消费或充值损失，由此带来的损失由用户自行承担。

<h3>免责事由</h3>
13.您知悉并同意，PaperWonder不因下述任一情况而可能导致的任何损害赔偿承担责任，包括但不限于财产、收益、数据资料等方面的损失或其它无形损失：
（1）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素导致充值系统或服务不能正常运作；
（2）由于黑客攻击、电信部门技术调整或故障、系统维护等原因而造成的系统服务中断或者延迟；
（3）由于政府命令、法律法规的变更、司法机关及行政机关的命令、裁定等原因而导致的系统服务中断、终止或延迟；
（4）由于您将账户密码告知他人或未保管好自己的密码或与他人共享账户或任何其他非PaperWonder的过错，导致您的个人资料泄露；
（5）由于与PaperWonder链接或合作的其它网站（如网上银行等）所造成的银行账户信息、身份信息泄露及由此而导致的任何法律争议和后果；
（6）您（包括未成年人用户）向本公司提供错误、不完整、不实信息等，造成不能使用 B账户或遭受任何其他损失；
（7）如因系统维护或升级的需要而需暂停充值服务时，我们将尽可能事先进行通知。对于充值服务的中断或终止而给您造成的任何损失，我们无须对您或任何第三方承担任何责任。

14.因您自身的原因导致PaperWonder无法提供豆币购买服务或提供豆币购买服务时发生任何错误而产生的任何损失或责任，由您自行负责，PaperWonder不承担责任，包括但不限于：
（1）您未按照本协议或PaperWonder不时公布的任何规则进行操作；
（2）因您的PaperWonder账号失效、丢失、被封停；
（3）因您绑定的第三方支付机构账户的原因导致的损失或责任，包括您使用未经认证的第三方支付账户或使用非您本人的第三方支付账户，您的第三方支付账户被冻结、查封等；
（4）因您个人的故意或重大过失所造成的财产损失。

<h3>违约责任</h3>
如您违反本协议项下的任何规则、声明、承诺及保证，我们保留根据实际损失向您追究责任的权利。

<h3>法律适用与争议解决</h3>
本协议的订立、效力、解释、履行、修改和终止以及争议的解决适用中华人民共和国法律。因解释和履行本协议而发生的任何争议，本协议双方应首先通过友好协商的方式加以解决。如果在一方向其他方发出要求协商解决的书面通知后 30天之内争议仍然得不到解决，则应将争议提交广州仲裁委员会按照其仲裁规则进行仲裁。仲裁裁决为一裁终局，对双方均有法律约束力。

<h3>其他</h3>
1.本协议项下所有的通知均可通过重要页面公告、平台站内信、电子邮件等方式进行，该等通知于发送之日视为已送达收件人。

2.本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的，未赋予本协议各方其他权利。

3.如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。

4.本协议中的标题仅为方便而设，不具法律或契约效果。
`;